import { IonBackButton, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonChip, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonImg, IonInput, IonLabel, IonMenuButton, IonNote, IonPage, IonRefresher, IonRefresherContent, IonRow, IonSpinner, IonText, IonTextarea, IonTitle, IonToolbar, RefresherEventDetail, useIonRouter, useIonViewDidEnter, useIonViewDidLeave } from '@ionic/react';
import React, { useEffect, useRef, useState } from 'react';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { arrowForwardCircleOutline, checkmarkCircleOutline } from 'ionicons/icons';
import { useAppContext } from '../AppProvider';

const Support: React.FC = () => {
    const [disableSubmit, setDisableSubmit] = useState<boolean>(true);
    const [sent, setSent] = useState<boolean>(false);
    
    const { networkStatus, getAppStatus, authKey, authenticateMember, authorizedMember, getAuthorizedMember, setShowLoader, settings, SWFullHorizLogo, SWTextDarkLogo, textLogoLoaded, fadeInTextLogo, showToast, present } = useAppContext();
    
    const router = useIonRouter();
    const subjectInput = useRef<any>();
    const messageText = useRef<any>();
    const submitBtn = useRef<HTMLIonButtonElement>(null);
    const loadingOverlay = useRef<any>();
        
    //
    // Authenticate Member
    //
    useIonViewDidEnter(() => { 
        const authenticate = async () => {
            const appstat = await getAppStatus();

            if (!networkStatus && appstat === 'No') {
                router.push('/connection', 'forward');
            } else {
                const authenticated = await authenticateMember();  
                setShowLoader(false);
                if(!authenticated || authenticated.mt == '') router.push('/login', 'forward');
            }
        };
        authenticate();
    }); 


    //
    // Clear the log-in form upon leaving page
    //
    useIonViewDidLeave(() => {
        setSent(false);
        resetForm();        
    });


    //
    // Validate Form
    //
    const validateForm = () => {
        const subject = subjectInput.current.value;
        const message = messageText.current.value;
        const disable = (subject.length < 2 || message.length < 10);
        setDisableSubmit(disable);
    };


    //
    // Reset Form
    //
    const resetForm = () => {
        if(subjectInput.current) subjectInput.current.value = '';
        if(messageText.current) messageText.current.value = '';
        if(submitBtn.current) submitBtn.current.innerHTML = 'Send Message';
        setDisableSubmit(true);
    };


    //
    // Submit Contact Form
    //
    const submitForm = async (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        setDisableSubmit(true);
        if(submitBtn.current) submitBtn.current.innerHTML = 'Sending...';

        try {
            const form = e.target; 
            const formData = new FormData(form);
            formData.append('mt', authorizedMember.memberToken);
            const response = await fetch('https://api.besolowise.com/members/support/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });

            if(response.ok) {
                const obj = await response.json(); 
                //console.log(obj);
                if(obj.success) {
                    resetForm();
                    setSent(true);
                } else {
                    if(submitBtn.current) submitBtn.current.innerHTML = 'Send Message';
                    setDisableSubmit(false);
                    showToast({
                        message: 'Messaging Error: ' + obj.message,
                        duration: 3000,
                        color: 'danger'
                    });
                }

            } else {
                showToast({
                    message: 'Response Error. Try again.',
                    duration: 2500,
                    color: 'danger'
                });  
            }   

        } catch(error) {
            showToast({
                message: 'Connection Error: ' + error + '. Try again.',
                duration: 3000,
                color: 'danger'
            });
        } 
    };


    const handleRefresh = (event: CustomEvent<RefresherEventDetail>) => {
        setTimeout(() => {
          getAuthorizedMember(authKey.mt);
          event.detail.complete();
        }, 2000);
    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot='start'>
                        <IonBackButton color={'tertiary'}>Back</IonBackButton>
                    </IonButtons>
                    <IonTitle><IonImg className={textLogoLoaded ? 'fade-in' : 'fade-out'} src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo} onIonImgDidLoad={fadeInTextLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton color={'tertiary'} />
                    </IonButtons>                    
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding account-content-bg">
                {/*<div className='ion-text-center'>
                    <img src={SWOwlLogo} alt='SoloWise' style={{'maxWidth': '77px'}} />
                </div>*/}              
                <div className='ion-padding-bottom'>
                    <h1 className='ion-text-center'>Technical Support</h1>
                </div>
                <IonGrid fixed>
                    <IonRow class='ion-justify-content-center'>
                        <IonCol size='12' sizeMd='10' sizeLg='8' sizeXl='8'>
                            <IonCard className='ion-padding'>
                                <IonCardHeader>
                                    <h2 className='ion-no-margin ion-text-center'><IonText color={'dark'}><strong>Hi, {authorizedMember.memberFirstName}!</strong><br /><hr />Need to contact us?</IonText></h2>
                                </IonCardHeader>
                                <IonCardContent>                                    
                                    <p className='ion-text-center'>You can submit your comment, question, or bug report below, and we'll reply as quickly as possible via email to:</p>
                                    <p className='ion-text-center'><strong>{authorizedMember.memberEmail}</strong></p>

                                    {!sent 
                                        ?   <form className='ion-margin-top' onSubmit={submitForm}>   
                                                <IonLabel className='ion-margin-bottom ion-margin-top' color={'dark'}><b>Subject</b> <em className='required'>Required</em></IonLabel>
                                                <IonInput autoCapitalize={'sentences'} className='ion-margin-bottom' counter fill='outline' minlength={5} name='messageSubject' onKeyUp={validateForm} ref={subjectInput} type='text'></IonInput>

                                                <IonLabel className='ion-margin-bottom ion-margin-top' color={'dark'}><b>Message</b> <em className='required'>Required</em></IonLabel>
                                                <IonTextarea autoCapitalize={'sentences'} autoGrow={true} className='ion-margin-bottom' counter fill='outline' maxlength={500} minlength={10} name='messageBody' onKeyUp={validateForm} ref={messageText}></IonTextarea>
                                                
                                                <IonButton className='ion-margin-top ion-margin-bottom' color={disableSubmit ? 'tertiary' : 'secondary'} type='submit' expand='block' ref={submitBtn} disabled={disableSubmit}>
                                                    Send Message <IonIcon icon={arrowForwardCircleOutline} slot='end'></IonIcon>
                                                </IonButton>
                                            </form>
                                        :   <>
                                                <p className='ion-text-center'><IonChip color={'success'}><IonIcon icon={checkmarkCircleOutline}></IonIcon> <IonLabel>Your message was sent</IonLabel></IonChip></p>
                                            </>
                                    }
                                </IonCardContent>
                            </IonCard>  
                        </IonCol>
                    </IonRow>
                </IonGrid>  
            </IonContent>
        </IonPage>
    );
};

export default Support;